import { serviceRouteConstants } from "@/Constants/routingConstants";

import { post } from ".";
import { systemAllRequests } from "../utilities/utils";

export const _fetchContractDetail = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.contractDetail,
    data: data,
  };
  return await post(request);
};

/**
 * Asynchronously fetches contract shifts data.
 *
 * @param {Object} data - The data to be sent with the request
 * @return {Promise} The result of the post request
 */
export const _fetchContractShifts = async (data) => {
  const postData = {
    contract_id: data.contract_id,
    dates: data.dates,
    forExpand: data.forExpand ? data.forExpand : 0,
    page: data.currentPage,
    sortByColumn: data.sortByColumn,
    sortByOrder: data.sortByOrder,
  };
  systemAllRequests({
    request: postData,
    page: "contract_shifts",
    route: "get_unfilled_contract_shifts",
    method: "POST",
  });
  const request = {
    endPoint: serviceRouteConstants.contractShifts,
    data: postData,
  };
  return await post(request);
};

/**
 * Asynchronously fetches applicant lists.
 *
 * @param {Object} data - The data to be sent with the request
 * @return {Promise} The response from the post request
 */
export const _fetchApplicantLists = async (data) => {
  const postData = {
    contract_id: data.contract_id,
    search: data.search,
    page: data.currentPage,
    contract_status: data.contract_status,
    sortByColumn: data.sortByColumn,
    sortByOrder: data.sortByOrder,
  };
  const request = {
    endPoint: serviceRouteConstants.contractApplicationList,
    data: postData,
  };
  return await post(request);
};

export const _fetchTerminatedShifts = async (data) => {
  const postData = {
    contract_id: data.contract_id,
    dates: data.dates,
    currentPage: data.currentPage,
    page: data.currentPage,
    sortByColumn: data.sortByColumn,
    sortByOrder: data.sortByOrder,
  };

  systemAllRequests({
    request: postData,
    page: "contract_terminated_shifts",
    route: "get_contract_terminated_shifts",
    method: "POST",
  });
  const request = {
    endPoint: serviceRouteConstants.contractTerminatedShifts,
    data: postData,
  };
  return await post(request);
};
